import React from "react";
import {
  DECCAN_MOBILE_TAB,
  DECCAN_URL,
  GENERAL_ERROR_MSG,
  PRAJAVANI_MOBILE_TAB,
  PRAJAVANI_URL,
  REDIRECT_URL,
} from "../contant";
import DeccanOTPPage from "./DeccanPages/DeccanOTPPage";
import PrajavaniOTPPage from "./PrajavaniPages/PrajavaniOTPPage";
import {
  clearPasswordlessLoginAttemptInfo,
  consumePasswordlessCode,
  resendPasswordlessCode,
} from "supertokens-web-js/recipe/thirdpartypasswordless";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import { doesSessionExist } from "supertokens-web-js/recipe/session";
import { fetchUserData, getAppFlag } from "../utiles";

export default function OtpPage({
  verifyOTPHandler,
  updatedFieldData,
  fieldWhichIsUpdated,
  resendOTPHandler,
  setUserOTP,
  userOtpError,
  userOTP,
  setIsDisableUserVerifyBtn,
  isDisableUserVerifyBtn,
  setUserOtpError
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const callbackUrl = localStorage.getItem("callbackUrl") || "";
  const tabDetail = localStorage.getItem("tab_detail") || "";
  const emailRequired = localStorage.getItem("emailRequired") || "";
  const signupMessage = localStorage.getItem("signupMessage") || "";
  const numberOfDigits = 6;
  const [OTP, setOTP] = React.useState("");
  const [otpError, setOtpError] = React.useState(null);
  const [isDisableVerifyBtn, setIsDisableVeifyBtn] = React.useState(false);
  const [isDisableResendBtn, setIsDisableResendBtn] = React.useState(false);
  const [progress, setProgress] = React.useState(30);

  const checkSession = async () => {
    try {
      if (await doesSessionExist()) {
        window.location.assign(
          `${callbackUrl}?access_token=${localStorage.getItem(
            "access-token"
          )}&refresh_token=${localStorage.getItem("refresh-token")}`
        );
      } else {
        // console.log("not logged in");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const isEmailUpdateOrPhoneNumber =
    fieldWhichIsUpdated === "email"
      ? "post_change_email"
      : "post_change_phonenumber";
  React.useEffect(() => {
    let intervalId;
    if (!pathname.includes(isEmailUpdateOrPhoneNumber)) {
      intervalId = setInterval(checkSession, 5000);
    }
    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (progress > 0) {
        setProgress((prevProgress) => Math.max(prevProgress - 1));
      }
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
    }, 30000);

    return () => clearInterval(interval);
  }, [progress]);

  async function handleOTPInput() {
    const errorMsg = getAppFlag({ appUrl: DECCAN_URL })
      ? "Invalid OTP"
      : getAppFlag({ appUrl: PRAJAVANI_URL })
      ? "ಒಟಿಪಿ ಅಮಾನ್ಯ"
      : "";
    setIsDisableVeifyBtn(true);
    setIsDisableResendBtn(true);
    if (OTP.length === numberOfDigits) {
      try {
        let response = await consumePasswordlessCode({
          userInputCode: OTP,
        });
        if (response.status === "OK") {
          await clearPasswordlessLoginAttemptInfo();
          localStorage.setItem(
            "access-token",
            response.fetchResponse.headers.get("st-access-token")
          );
          localStorage.setItem(
            "refresh-token",
            response.fetchResponse.headers.get("st-refresh-token")
          );
          if (
            response.createdNewRecipeUser &&
            response.user.loginMethods.length === 1
          ) {
            // user sign-up into the web-sso app success
            navigate("/auth/authenticate");
          } else {
            // user sign-in into the web-sso app success
            // navigate("/auth/profile")
            const userData = await fetchUserData();
            const isEMailPresent = userData?.userData?.emails?.length > 0;
            if (
              (tabDetail === DECCAN_MOBILE_TAB ||
                tabDetail === PRAJAVANI_MOBILE_TAB) &&
              emailRequired === "true" &&
              !isEMailPresent
            ) {
              navigate("/auth/change_email");
            } else {
              window.location.assign(
                `${callbackUrl}?access_token=${response.fetchResponse.headers.get(
                  "st-access-token"
                )}&refresh_token=${response.fetchResponse.headers.get(
                  "st-refresh-token"
                )}`
              );
            }
          }
        } else if (response.status === "INCORRECT_USER_INPUT_CODE_ERROR") {
          // the user entered an invalid OTP
          setOtpError(errorMsg);
          setIsDisableVeifyBtn(false);
          setIsDisableResendBtn(false);
        } else if (response.status === "EXPIRED_USER_INPUT_CODE_ERROR") {
          // it can come here if the entered OTP was correct, but has expired because
          // it was generated too long ago.
          setOtpError(errorMsg);
          setIsDisableVeifyBtn(false);
          setIsDisableResendBtn(false);
        } else {
          // this can happen if the user tried an incorrect OTP too many times.
          // or if it was denied due to security reasons in case of automatic account linking

          // we clear the login attempt info that was added when the createCode function
          // was called - so that if the user does a page reload, they will now see the
          // enter email / phone UI again.
          await clearPasswordlessLoginAttemptInfo();
          toast.error("Login failed. Please try again");
          setIsDisableVeifyBtn(false);
          setIsDisableResendBtn(false);
          navigate(`/auth?${REDIRECT_URL}=${callbackUrl}`);
        }
      } catch (err) {
        console.log("error", err);
        if (err.isSuperTokensGeneralError === true) {
          // this may be a custom error message sent from the API by you.
          toast.error(err.message);
        } else {
          toast.error(GENERAL_ERROR_MSG);
        }
        setIsDisableVeifyBtn(false);
        setIsDisableResendBtn(false);
      }
    } else {
      setIsDisableVeifyBtn(false);
      setIsDisableResendBtn(false);
      setOtpError(errorMsg);
    }
  }

  async function resendOTP() {
    setIsDisableResendBtn(true);
    const infoMsg =
      tabDetail === DECCAN_MOBILE_TAB || tabDetail === PRAJAVANI_MOBILE_TAB
        ? "Please check your phone for the OTP"
        : "Please check your email for the OTP";
    try {
      let response = await resendPasswordlessCode();
      if (response.status === "RESTART_FLOW_ERROR") {
        // this can happen if the user has already successfully logged in into
        // another device whilst also trying to login to this one.

        // we clear the login attempt info that was added when the createCode function
        // was called - so that if the user does a page reload, they will now see the
        // enter email / phone UI again.
        await clearPasswordlessLoginAttemptInfo();
        toast.error("Login failed. Please try again");
        navigate(`/auth?${REDIRECT_URL}=${callbackUrl}`);
      } else {
        // OTP resent successfully.
        setProgress(30);
        toast.info(infoMsg);
      }
    } catch (err) {
      console.log("error", err);
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        toast.error(err.message);
      } else {
        toast.error(GENERAL_ERROR_MSG);
      }
    } finally {
      setIsDisableResendBtn(false);
    }
  }

  return (
    <>
      {getAppFlag({ appUrl: PRAJAVANI_URL }) ? (
        <PrajavaniOTPPage
          reference={callbackUrl}
          OTP={OTP}
          setOTP={setOTP}
          otpError={otpError}
          setOtpError={setOtpError}
          isDisableVerifyBtn={isDisableVerifyBtn}
          setIsDisableVeifyBtn={setIsDisableVeifyBtn}
          isDisableResendBtn={isDisableResendBtn}
          setIsDisableResendBtn={setIsDisableResendBtn}
          tabDetail={tabDetail}
          handleOTPInput={
            pathname.includes(isEmailUpdateOrPhoneNumber)
              ? verifyOTPHandler
              : handleOTPInput
          }
          resendOTP={
            pathname.includes(isEmailUpdateOrPhoneNumber)
              ? resendOTPHandler
              : resendOTP
          }
          progress={progress}
          pathname={pathname}
          fieldTobeUpdateData={updatedFieldData}
          setUserOTP={setUserOTP}
          userOTP={userOTP}
          userOtpError={userOtpError}
          setIsDisableUserVerifyBtn={setIsDisableUserVerifyBtn}
          isDisableUserVerifyBtn={isDisableUserVerifyBtn}
          emailRequired={emailRequired}
          signupMessage={signupMessage}
          isEmailUpdateOrPhoneNumber ={isEmailUpdateOrPhoneNumber}
          setUserOtpError = {setUserOtpError}
        />
      ) : getAppFlag({ appUrl: DECCAN_URL }) ? (
        <DeccanOTPPage
          reference={callbackUrl}
          OTP={OTP}
          setOTP={setOTP}
          otpError={otpError}
          setOtpError={setOtpError}
          isDisableVerifyBtn={isDisableVerifyBtn}
          setIsDisableVeifyBtn={setIsDisableVeifyBtn}
          isDisableResendBtn={isDisableResendBtn}
          setIsDisableResendBtn={setIsDisableResendBtn}
          tabDetail={tabDetail}
          handleOTPInput={
            pathname.includes(isEmailUpdateOrPhoneNumber)
              ? verifyOTPHandler
              : handleOTPInput
          }
          resendOTP={
            pathname.includes(isEmailUpdateOrPhoneNumber)
              ? resendOTPHandler
              : resendOTP
          }
          progress={progress}
          pathname={pathname}
          fieldTobeUpdateData={updatedFieldData}
          setUserOTP={setUserOTP}
          userOTP={userOTP}
          userOtpError={userOtpError}
          setIsDisableUserVerifyBtn={setIsDisableUserVerifyBtn}
          isDisableUserVerifyBtn={isDisableUserVerifyBtn}
          emailRequired={emailRequired}
          signupMessage={signupMessage}
          isEmailUpdateOrPhoneNumber = {isEmailUpdateOrPhoneNumber}
          setUserOtpError = {setUserOtpError}
        />
      ) : null}
    </>
  );
}
